import { Button, Text } from '#atoms';
import { Modal } from '#molecules';
import { useScheduleManage } from '#providers/SchedulesManage';
import { useToast } from '#providers/ToastProvider';
import { RepetitionType } from '#types/schedule';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { ModalButtonContainer } from 'src/components/pages/WeeklyCalenderDetail/styles';
import {
  Container,
  DayBox,
  HeaderBox,
  RepeatInfoBox,
  RepeatTypeBox,
  WeekDayList
} from './styles';
import { getRepeatTitle, getRepeatType } from './utils';

const weekDay = ['일', '월', '화', '수', '목', '금', '토'];
const buttonList = ['매일', '매주', '없음'];

export function WeeklyRepeat() {
  const { showToast } = useToast();
  const navigate = useNavigate();

  const { selectedLecture, setSelectedLecture } = useScheduleManage();

  const [repeatType, setRepeatType] = useState(
    getRepeatType(selectedLecture.repetition?.type)
  );
  const [daysOfWeek, setDaysOfWeek] = useState<Set<number>>(new Set());

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [searchParams] = useSearchParams();
  const lectureScheduleId = decodeURIComponent(
    searchParams.get('lecture-schedule-id') ?? ''
  );

  const isModify = !!lectureScheduleId;

  const handleToggleDaysOfWeek = (indexWeek: number) => {
    const newState = new Set(daysOfWeek);

    if (newState.has(indexWeek)) {
      newState.delete(indexWeek);
    } else {
      newState.add(indexWeek);
    }
    setDaysOfWeek(newState);
  };

  const handleSubmit = () => {
    if (isModify) {
      setIsOpenModal(true);
      return;
    }

    onSave();
  };

  const onSave = () => {
    if (repeatType === '매주' && daysOfWeek.size === 0) {
      showToast({
        type: 'fail',
        message: '요일을 선택해주세요.'
      });
      return;
    }

    const arrayDaysOfWeek = Array.from(daysOfWeek);
    const repetition: RepetitionType | undefined =
      repeatType === '없음'
        ? undefined
        : {
            type: repeatType === '매일' ? 'DAILY' : 'WEEKLY',
            interval: 1,
            daysOfWeek: arrayDaysOfWeek
          };

    setSelectedLecture({
      repetition
    });
    navigate(-1);
  };

  useEffect(() => {
    if (selectedLecture.repetition?.daysOfWeek) {
      const state = new Set(selectedLecture.repetition?.daysOfWeek);
      setDaysOfWeek(state);
    }
  }, [selectedLecture]);

  return (
    <Container>
      <HeaderBox>
        <Text>반복</Text>
        <div>
          <Button background="transparent" onClick={handleSubmit}>
            완료
          </Button>
        </div>
      </HeaderBox>
      <div>
        <RepeatInfoBox>
          <Text>{getRepeatTitle(repeatType, Array.from(daysOfWeek))}</Text>
        </RepeatInfoBox>
        <RepeatTypeBox>
          {buttonList.map((item, index) => (
            <Button
              key={index}
              background={repeatType === item ? undefined : 'anti'}
              onClick={() => setRepeatType(item)}
            >
              {item}
            </Button>
          ))}
        </RepeatTypeBox>

        {repeatType === '매주' && (
          <WeekDayList>
            {weekDay.map((item, index) => (
              <DayBox isSelected={daysOfWeek.has(index)} key={index}>
                <Button onClick={() => handleToggleDaysOfWeek(index)}>
                  {item}
                </Button>
              </DayBox>
            ))}
          </WeekDayList>
        )}
      </div>

      {isOpenModal && (
        <Modal onClose={() => setIsOpenModal(false)}>
          <div>
            <Text style={{ textAlign: 'center' }}>
              오늘 이후에 수업 일정이 존재하는 경우 <br /> 삭제 후 반복 일정이
              생성돼요.
            </Text>
          </div>

          <ModalButtonContainer>
            <Button onClick={() => setIsOpenModal(false)}>취소</Button>
            <Button
              onClick={() => {
                onSave();
              }}
              background="anti"
            >
              확인
            </Button>
          </ModalButtonContainer>
        </Modal>
      )}
    </Container>
  );
}
